// extracted by mini-css-extract-plugin
export default {"copyrightText":"Footer_copyrightText__+ppU2"};